<template>
  <i class="icon icon-diagram-dash-circle" />
</template>

<style lang="scss" scoped>
@import '@/styles/spinner';
</style>
